// Copyright (c) Ensho Health, 2022 to present

import React from 'react';
import { Link } from 'react-router-dom';

import { StyledInfo } from './FormLogin.styles';

const LoginInfo = () => {
  return (
    <StyledInfo>
      <p>
        *By logging in you accept our <Link to="#">General Terms </Link>
        and <Link to="#">Terms of Use of Compass Web Application</Link>.
      </p>
      <p>
        Compass is the web application of Ensho Health, for ordering algorithmic
        analysis of electronic health infomation. Compass offers the possibility
        to place orders for services, follow progress, and read results. Compass
        also provides a feature that connects clinicians for knowledge sharing
        and further collaboration. The portal is free for all users and having
        an account does not obligate to anything
      </p>
      <p>
        To register for an account, click on the link "Request an account"
        above. If you have any questions about Compass or ordering please visit{' '}
        <a
          href="https://www.enshohealth.com/compass"
          target="_blank"
          rel="noreferrer"
        >
          enshohealth.com/compass
        </a>{' '}
        or contact our customer support at{' '}
        <a href="mailto:support@ensho.ai">support@ensho.ai</a>.
      </p>
    </StyledInfo>
  );
};

export default LoginInfo;
